export default __webpack_public_path__ + "static/lilies-9671ac6225614128cb77f1b70c6d9331.mp4";